import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="w-full px-4 py-10 md:px-10 border-t border-border-dark mt-auto">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col items-center gap-6">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img src="/UPITrackrLogo.png" alt="UPI Trackr Logo" className="h-8 w-auto" />
            <span className="text-white font-bold text-lg">UPI Trackr</span>
          </Link>
          <div className="flex gap-6 text-sm text-text-muted">
            <Link className="hover:text-white transition-colors" to="/privacy-policy" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Privacy Policy</Link>
            <Link className="hover:text-white transition-colors" to="/terms-and-conditions" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Terms of Service</Link>
            <Link className="hover:text-white transition-colors" to="/delete-account" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Delete Account</Link>
            <a className="hover:text-white transition-colors" href="#">Contact Support</a>
          </div>
        </div>
        <div className="text-center text-xs text-text-muted/50 mt-8">
          © {new Date().getFullYear()} UPI Trackr. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
